import { queryKeys } from '@core/Data/ReactQuery/constants'
import { useQuery } from '@tanstack/react-query'
import { getCountryEntitlements } from './api'

export const useGetCountryEntitlements = () => {
  const { data } = useQuery({
    queryKey: [queryKeys.countryEntitlementCheck],
    queryFn: getCountryEntitlements,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 20,
  })

  if (!data) return true

  return data.data.isCountryEntitled
}
